import { Radio } from "@/eworkitComponents";
import { withFormikField } from "@/formikComponents";

export const FormikRadio = withFormikField(Radio);
